import type { GeocodingResult } from '@camper-diary/shared';
import { api } from './client';

export type Geo = GeocodingResult;

export function searchAddress(q: string, limit = 5) {
  const params = new URLSearchParams({ q, limit: String(limit) });
  return api<Geo[]>(`/geocoding/search?${params.toString()}`);
}

export function reverseGeocode(lat: number, lon: number) {
  const params = new URLSearchParams({ lat: String(lat), lon: String(lon) });
  return api<Geo | null>(`/geocoding/reverse?${params.toString()}`);
}
